// Geometry `Spds::Core::Popover` measures and publishes for its stylesheet to compose. Coordinates
// are the anchor's own edge; the gap is opened from there so the offset stays a CSS length the
// browser resolves rather than a number the component has to understand.
export const ANCHOR_DIRECTION_PROPERTY = '--spds-popover-anchor-direction';
export const ANCHOR_DOWNWARD = '1';
export const ANCHOR_LEFT_PROPERTY = '--spds-popover-anchor-left';
export const ANCHOR_OFFSET_PROPERTY = '--spds-popover-anchor-offset';
export const ANCHOR_TOP_PROPERTY = '--spds-popover-anchor-top';
export const ANCHOR_UPWARD = '-1';

export default {
  ANCHOR_DIRECTION_PROPERTY,
  ANCHOR_DOWNWARD,
  ANCHOR_LEFT_PROPERTY,
  ANCHOR_OFFSET_PROPERTY,
  ANCHOR_TOP_PROPERTY,
  ANCHOR_UPWARD,
};
